// // import { secreteKey } from "./secreteKey";
import CryptoJS from "crypto-js";
import { AES } from "crypto-js";
const secreteKey =
  "jkfeiwafurefjusndkale5654259801p3h4jngj4875ytfh87b2c1i2873ybxr9384cx";
// export const decryptResponse = (encryptedData) => {
//   //   console.log("encryptedData", encryptedData);
//   const bytes = AES.decrypt(encryptedData, secreteKey);
//   const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
//   console.log("decryptedData", decryptedData);
//   return decryptedData;
// };

export const decryptResponse = (encryptedData) => {
  if(!encryptedData) return  
  
  const decryptedData = CryptoJS?.AES?.decrypt(
    encryptedData,
    secreteKey
  ).toString(CryptoJS.enc.Utf8);
  if (typeof encryptedData !== String) {
    return JSON.parse(decryptedData);
  } else {
    return encryptedData;
  }
};
